/* eslint-disable class-methods-use-this */
import { toEuro } from 'utils/Common/amount-utils'
import { formatDate, parseDate } from 'utils/Common/date-utils'
import {
  DocumentWDHTableAPI,
  DocumentWDHTableEntity,
} from 'utils/__interfaces/Documents/DocumentTableAPI'
import { normalizeString } from 'utils/Common/ts-utils'

class DocumentWDHTableNormalizer {
  normalize(tableDocument: DocumentWDHTableAPI[]): DocumentWDHTableEntity[] {
    return tableDocument.map((item) => {
      // Concat address
      const address = `${normalizeString(item.raisonSociale)}
      ${normalizeString(item.rueAdresse)} ${normalizeString(
        item.codePostalAdresse
      )} ${normalizeString(item.villeAdresse)}`

      return {
        id: `${item.idDocument};${item.typeDocument};${item.numDocument}`,
        typeDocument: item.typeDocument,
        numDocument: item.numDocument,
        anneeMois: item.anneeMois
          ? formatDate(parseDate(item.anneeMois), 'MM/YYYY')
          : undefined,
        dateDocument: item.dateDocument
          ? formatDate(parseDate(item.dateDocument), 'DD/MM/YYYY')
          : undefined,
        dateCreation: item.dateCreation
          ? formatDate(parseDate(item.dateCreation), 'DD/MM/YYYY')
          : undefined,
        montant:
          item.montantTotalHT !== null
            ? toEuro(item.montantTotalHT ?? 0, 2)
            : '',
        etablissement: address,
        gedId: item.gedId,
        codeDossier: item.codeDossier ?? '',
      }
    })
  }
}

export default new DocumentWDHTableNormalizer()
